import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface HeaderLogoProps {
  url?: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  position: string;
}

const HeaderLogoComponent: React.FC<HeaderLogoProps> = ({
  url,
  alt,
  width,
  height,
  position,
}) => {
  if (!url) return null;
  return (
    <div className={`peptalk-chat-logo peptalk-chat-logo-${position}`}>
      <img
        src={url}
        alt={alt}
        width={width}
        height={height}
        className="peptalk-logo-image"
      />
    </div>
  );
};

export const HeaderLogo: React.FC<HeaderLogoProps> = (
  props: HeaderLogoProps
) => {
  const Component = useCustomComponent({
    componentName: 'HeaderLogo',
    Component: HeaderLogoComponent,
  });
  return <Component {...props} />;
};
